module.exports = __webpack_public_path__ + "img/QuicklyImportselect.8e35ec96.svg";